export default __webpack_public_path__ + "static/media/MBB.fbaef469.svg";